<template>

  <p class="notification" :class="{'active': close}" v-show="close">New look, new products. Available exclusively at <a href="https://auraglow.com/" target="_blank" class="notification__link">Auraglow.com</a> <CloseIcon class="notification__icon" @click="close = false" /></p>

  <Nav @openAndClose="openAndClose" />
  
  <Cart class="cart" @openAndClose="openAndClose(boolean)" :class="{'active': modalCart}"/>
  
  <router-view/>
  
  <Footer />
  
</template>

<script>
import { mapState } from "vuex";

import Nav from '@/components/nav/Nav.vue'
import CloseIcon from '@/assets/images/icons/CloseIcon.vue'
import CartIcon from "@/assets/images/icons/CartIcon.vue";
import Footer from '@/layouts/Footer/Footer.vue'
import Cart from "@/components/modalCart/Cart";

export default {
  name: "App",
  components: {
    Nav,
    CloseIcon,
    Footer,
    CartIcon,
    Cart
  },
  data() {
    return {
      close: true,
      modalCart: false
    }
  },
  computed: {
    ...mapState(["cart"]),
  },
  methods: {
    openAndClose(boolean) {

      if (this.modalCart) {
        this.modalCart = boolean
      } else {
        this.modalCart = !this.modalCart
      }

    }
  }
}

</script>